var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGrowth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M443.591,0H71.313C32.795,0,0,29.886,0,68.409v372.278C0,479.205,32.795,512,71.313,512h372.278 C482.114,512,512,479.205,512,440.687V68.409C512,29.886,482.114,0,443.591,0z M488.727,440.687 c0,25.688-19.443,48.04-45.136,48.04H71.313c-25.688,0-48.04-22.352-48.04-48.04V68.409c0-25.693,22.352-45.136,48.04-45.136 h372.278c25.693,0,45.136,19.443,45.136,45.136V440.687z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M397.921,104.727h-82.284c-6.426,0-11.636,5.21-11.636,11.636c0,6.426,5.21,11.636,11.636,11.636h55.274l-91.445,121.193 l-48.693-49.057c-2.352-2.352-5.562-3.756-8.92-3.568c-3.324,0.199-6.404,1.716-8.454,4.335l-128,162.864 c-3.972,5.051-3.097,12.347,1.96,16.312c2.131,1.676,4.665,2.477,7.182,2.477c3.443,0,6.858-1.534,9.153-4.454l119.898-152.6 L272.5,274.41c2.38,2.386,5.682,3.567,9.051,3.381c3.364-0.24,5.318-1.928,7.341-4.626L384,144.832v52.48 c0,6.426,5.21,11.636,11.636,11.636c6.426,0,11.636-5.21,11.636-11.636v-82.404C407.273,108.483,404.346,104.727,397.921,104.727z "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrowth);
export default __webpack_public_path__ + "static/media/growth.b459eab9c8434426ac67c69e0d53226a.svg";
export { ForwardRef as ReactComponent };